import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-users-groups-list',
	templateUrl: './users-groups-list.component.html',
	styleUrls: ['./users-groups-list.component.css'],
})
export class UsersGroupsListComponent extends ListComponent {
	protected itemsBeforeDataLoad = 0;
	protected apiUrl = 'usersGroups';
	data: Array<any>;
	tableRows = [{ id: 'name', name: 'Nazwa' }];
	filters = {
		status: 1,
	};
}
